/** Compatibility export; the business domain owns this implementation. */
export { estimateDemandSales } from '@domains/research/shared';
